import { FontWeights, makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  leftPanelContainer: {
    flex: 1,
    overflow: 'auto',
    paddingBottom: 200,
    height: 'calc(100vh - 500px)',
    borderWidth: 19,
    '::-webkit-scrollbar': {
      width: 5,
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.neutralLight,
      borderRadius: '6px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.palette.neutralLighter,
    },
  },
  linkHover: {
    height: 40,
    ':hover': {
      color: theme.palette.blue,
      backgroundColor: theme.palette.neutralLighter,
    },
  },

  textStyle: {
    fontWeight: FontWeights.regular,
    ':hover': {
      color: theme.palette.blue,
    },
  },
  selectedNodeStyle: {
    color: theme.palette.blue,
  },
}));
